import { RuleId } from '@wix/a11y-rules';
import { useCallback, useRef } from 'react';
import { resolveGroupAnalysisState } from './resolve-group-analysis-state';
const RULES_CONFIG = [RuleId.VALID_STATIC_PAGE_TITLE, RuleId.INACCESSIBLE_COMPONENTS, RuleId.INACCESSIBLE_LAYOUT, RuleId.HEADING_STRUCTURE, RuleId.STATIC_ALT_TEXT, RuleId.COLOR_CONTRAST, RuleId.MEDIA_ALTERNATIVES];
const RULE_PRIORITY_MAP = RULES_CONFIG.reduce((map, ruleId, index) => ({
  ...map,
  [ruleId]: index + 1
}), {});
function getGroupDataRuleIds(groupData) {
  var _groupData$analysisDa;
  return Object.keys((groupData == null || (_groupData$analysisDa = groupData.analysisData) == null || (_groupData$analysisDa = _groupData$analysisDa.summary) == null ? void 0 : _groupData$analysisDa.rulesStatusMap) ?? {});
}
function addMissingRules(baseRuleIds, pageId, inaccessibleComponentsPages, inaccessibleLayoutPages) {
  const rulesToAdd = new Set(baseRuleIds);
  if (inaccessibleComponentsPages.includes(pageId)) {
    rulesToAdd.add(RuleId.INACCESSIBLE_COMPONENTS);
  }
  if (inaccessibleLayoutPages != null && inaccessibleLayoutPages.includes(pageId)) {
    rulesToAdd.add(RuleId.INACCESSIBLE_LAYOUT);
  }
  return Array.from(rulesToAdd);
}
function sortRulesByPriority(ruleIds) {
  return ruleIds.sort((a, b) => {
    const priorityA = RULE_PRIORITY_MAP[a] ?? 999;
    const priorityB = RULE_PRIORITY_MAP[b] ?? 999;
    return priorityA - priorityB;
  });
}
function isAnalysisInProgress(groupData) {
  var _groupData$analysisDa2;
  const {
    isAnalyzing,
    isPendingResults
  } = resolveGroupAnalysisState(groupData == null ? void 0 : groupData.analysisState);
  return isAnalyzing || isPendingResults || !(groupData != null && (_groupData$analysisDa2 = groupData.analysisData) != null && (_groupData$analysisDa2 = _groupData$analysisDa2.summary) != null && _groupData$analysisDa2.rulesStatusMap);
}
export function useGetRuleIds() {
  const lastKnownRuleIds = useRef({});
  return useCallback(_ref => {
    let {
      getGroupData,
      pageId,
      inaccessibleComponentsPages,
      inaccessibleLayoutPages,
      pageData
    } = _ref;
    if (pageData != null && pageData.isMembershipCustomPage) {
      return [RuleId.INACCESSIBLE_COMPONENTS];
    }
    const groupData = getGroupData(pageId);
    if (isAnalysisInProgress(groupData) && lastKnownRuleIds.current[pageId]) {
      return lastKnownRuleIds.current[pageId];
    }
    const baseRuleIds = getGroupDataRuleIds(groupData);
    if (baseRuleIds.length === 0 && !lastKnownRuleIds.current[pageId]) {
      return [];
    }
    const allRuleIds = addMissingRules(baseRuleIds, pageId, inaccessibleComponentsPages, inaccessibleLayoutPages);
    const sortedRuleIds = sortRulesByPriority(allRuleIds);
    lastKnownRuleIds.current = {
      ...lastKnownRuleIds.current,
      [pageId]: sortedRuleIds
    };
    return sortedRuleIds;
  }, []);
}
//# sourceMappingURL=get-rule-ids.js.map